
export default class Source {
    constructor() {

        this.id = -1;

        this.name = null;

        this.ready = false;
        this.fromFile = false;

        this.originalContent = null; // Data from other format
        this.originalContentType = null;

        this.data = null; // Data will be loaded here
        
        this.needsLatLongInfo = false;
        this.latitudeIndex = null;
        this.longitudeIndex = null;

        this.providerId = null;
        this.datasetId = null;
        this.structure = [];
        this.properties = []; // { name, min, max, type, filter: { enable: false, filter: { min, max } } }


        this.request = null; // Request object will be stored here

        //example d'objet requete
        this.request = {
            filters: [
                {
                    column : 'date',
                    condition : '<',   // < | > | <= | >= | == | != | betweem | in | notin
                    value : [16546846465]
                },
                {
                    column : 'allowedPersons',
                    condition : '>=',
                    value : [20]
                },
                {
                    column : 'latitude',
                    condition : 'between',
                    value : [0, 90]
                }
            ],
            filtersCombine: ' (0 OR 1) AND 2 '
        }

        
        
    }

    init() {

    }
}